/* global s, s_gi, visitor, CommonAnalytics*/
/* eslint-disable no-case-declarations, no-global-assign */
import get from "../../helpers/get";
import concatValues from "./helpers/concatValues";
import getCustomerRef from "./helpers/getCustomerRef";
import viewportDimensions from "./helpers/viewportDimensions";

export const eventHandlers = {
  "tracking.navigation.pageInteraction": function(payload) {
    s = s_gi(s.account);
    s.linkTrackVars = "pageName,channel,server,eVar60,eVar61,prop8";
    const context = get(payload, "context");
    const interaction = get(payload, "interaction");
    const elementText = get(payload, "elementText");
    let linkType = "o";
    const overrides = {}; // Custom

    switch (context) {
      case "social icon":
        overrides.linkTrackVars = commons.setLinkTrackVars(["prop40"]);
        overrides.linkTrackEvents = commons.setLinkTrackEvents(["event120"]);
        s.prop40 = concatValues([context, interaction, elementText]);
        s.events = "event120";
        linkType = "e"; // Exit link
        break;
      case "country preferences":
        const isCountryUpdateManual = get(
          payload,
          "properties.formFields.country.isUpdateManual"
        );
        const isCurrencyUpdateManual = get(
          payload,
          "properties.formFields.currency.isUpdateManual"
        );
        const siteIDFrom = get(
          payload,
          "properties.formFields.country.siteIDFrom"
        );
        const siteIDTo = get(payload, "properties.formFields.country.siteIDTo");
        const countryISOFrom = get(
          payload,
          "properties.formFields.country.countryISOFrom"
        );
        const countryISOTo = get(
          payload,
          "properties.formFields.country.countryISOTo"
        );
        const languageTextFrom = get(
          payload,
          "properties.formFields.language.languageTextFrom"
        );
        const languageTextTo = get(
          payload,
          "properties.formFields.language.languageTextTo"
        );
        const currencyISOFrom = get(
          payload,
          "properties.formFields.currency.currencyISOFrom"
        );
        const currencyISOTo = get(
          payload,
          "properties.formFields.currency.currencyISOTo"
        );
        const storeFrom = get(
          payload,
          "properties.formFields.country.storeFrom"
        );
        const storeTo = get(payload, "properties.formFields.country.storeTo");
        overrides.linkTrackVars = commons.setLinkTrackVars(
          "eVar115,eVar112,eVar121,eVar122,eVar114,eVar123,eVar113,eVar124,eVar125".split(
            ","
          )
        );
        // change country
        if (countryISOFrom !== countryISOTo) {
          s.eVar112 = countryISOTo;
          s.eVar115 = siteIDTo;
          s.eVar121 = concatValues([siteIDFrom, siteIDTo]);
          s.eVar122 = concatValues([countryISOFrom, countryISOTo]);
        }
        // change language
        if (languageTextFrom !== languageTextTo) {
          s.eVar114 = languageTextTo;
          s.eVar123 = concatValues([languageTextFrom, languageTextTo]);
        }
        // change currency
        if (currencyISOFrom !== currencyISOTo) {
          s.eVar113 = currencyISOTo;
          s.eVar124 = concatValues([currencyISOFrom, currencyISOTo]);
        }

        const events = [];
        if (isCountryUpdateManual) {
          events.push("event2");
        }
        if (isCurrencyUpdateManual) {
          events.push("event100");
        }
        if (events.length > 0) {
          const joinedEvents = events.join(",");
          overrides.linkTrackEvents = commons.setLinkTrackEvents([
            joinedEvents
          ]);
          s.events = joinedEvents;
        }

        if (interaction === "saved") {
          const platform = (s.server && s.server.split(" ")[0]) || "undefined";
          const server = [platform, storeTo].join(" ");
          s.server = server;
          s.eVar125 = concatValues([storeFrom, storeTo]);
        }
        break;
      default:
        return;
    }
    s.tl(true, linkType, context, overrides);
  },
  "tracking.gdpr.pageLoad": function(payload) {
    const custRefQS = s.getQueryParamValue("custref", true);
    const countryISO = get(payload, "countryCode");
    const currency = get(payload, "currency");
    const customerID = getCustomerRef(payload, custRefQS);
    const customerRef = customerID ? customerID : "-1";
    const pageTitle = get(payload, "pageTitle");
    const pageType = get(payload, "pageType");
    const platform = get(payload, "platform");
    const storeCode = get(payload, "storeCode");

    s = s_gi(s.account);
    visitor.setCustomerIDs({
      customerId: customerRef
    });
    s.pageName = platform + " " + storeCode + "|" + pageTitle;
    s.products = "";
    s.eVar1 = s.getVisitNum();
    s.eVar6 = pageTitle;
    s.eVar10 = customerID;
    s.eVar17 = s.getNewRepeat(365);
    s.eVar19 = viewportDimensions();
    s.eVar47 = s.getPreviousValue(s.eVar6, "gpv_e47", "");
    s.eVar60 = pageTitle;
    s.eVar61 = pageTitle;

    s.linkTrackEvents = "event128";
    if ("performance" in window) {
      const navApi = window.performance.timing;
      s.eVar29 = navApi.responseStart - navApi.navigationStart;
      s.eVar30 = navApi.domContentLoadedEventEnd - navApi.navigationStart;
      s.events = "event128=" + s.eVar30;
    }

    try {
      s.eVar70 = s.getBagItems("0", "0", countryISO);
    } catch (e) {
      console.log(e);
    }
    s.channel = pageType;
    s.server = platform + " " + storeCode;
    s.campaign = s.getCampaignID();
    s.hier1 = pageType + "," + pageTitle;
    s.prop1 = pageTitle;
    s.prop2 = pageTitle;
    s.prop3 = pageTitle;
    s.prop4 = "";
    s.prop5 = s.getCustomTimeDate().toString();
    s.prop7 = countryISO + "|" + currency;
    s.prop8 = pageType;
    s.prop10 = s.getPreviousValue(s.pageName, "gpv_p10", "").toLowerCase();
    s.prop11 = encodeURI(window.location.href.replace(/%20/gi, "+"));
    s.prop29 =
      typeof Visitor !== "undefined"
        ? "VisitorAPI Present"
        : "VisitorAPI Missing";
    s.prop46 = s.Util.cookieRead("_s_pl");
    s.t();
  },
  "tracking.miniBag.miniBagInteraction": function(payload) {
    const context = get(payload, "context");
    if (context === "mini bag product delete") {
      s = s_gi(s.account);
      const deletedProductId = get(payload, "productId");
      s.product = deletedProductId;
      s.tl(true, "o", context);
    }
  }
};

let commons;

const siteChromeAnalytics = () => {
  if (window.CommonAnalytics) {
    commons = new CommonAnalytics(eventHandlers);
  }
};

export default siteChromeAnalytics;
